import { api } from "./configs/axiosConfigs";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const OrderAPI = {
  submit: async function (formData, cancel = false) {
    const response = await api.request({
      url: `/orders`,
      method: "POST",
      data: formData,
      signal: cancel
        ? cancelApiObject[this.submit.name].handleRequestCancellation().signal
        : undefined,
    });
    return response.data;
  },
};

const cancelApiObject = defineCancelApiObject(OrderAPI);
